import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import endpoint from "../../config/Axios";
import Loader from "../Loader";
export const downloadBase64PDF = (base64String, filename = "Document.pdf") => {
  // Remove the base64 prefix if it exists
  const base64 = base64String.split(";base64,").pop();

  // Convert base64 to a Blob
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });

  // Use FileSaver to save the blob as a PDF file
  saveAs(blob, filename);
};
const BatchDownload = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const base64ToCSV = (base64String, fileName = "Users.csv") => {
    // Decode the Base64 string
    const decodedData = atob(base64String);

    // Convert decoded data to a Uint8Array
    const uint8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }

    // Create a Blob with the correct MIME type
    const blob = new Blob([uint8Array], { type: "text/csv;charset=utf-8;" });

    // Trigger the file download
    saveAs(blob, fileName);
  };

  useEffect(() => {
    const search = location.search;
    if (search) {
      let searchParams = new URLSearchParams(search);
      const batch_id = searchParams.get("batch_id");
      const format = searchParams.get("format");
      if (batch_id) {
        setLoading(true);
        endpoint
          .get(
            `api/v1/convertBase?id=${batch_id}&success=true&format=${
              format ? format : "csv"
            }`
          )
          .then((res) => {
            if (res?.data?.response?.base_64) {
              if (format === "pdf") {
                downloadBase64PDF(res?.data?.response?.base_64);
              } else base64ToCSV(res?.data?.response?.base_64);
              window.close();
            }

            setLoading(false);
          });
      }
    }
    // eslint-disable-next-line
  }, [location.search]);

  return loading ? <Loader /> : null;
};

export default BatchDownload;
